class RepeatClick {
  constructor(time = 1000) {
    this.isClick = false;
    this.time = time;
  }
  setIsClick(_flag) {
    this.isClick = _flag;
    let timer = setTimeout(() => {
      this.isClick = !this.isClick
      clearTimeout(timer)
    }, this.time)
  }
  getIsClick() {
    return this.isClick
  }
}
export default RepeatClick;